import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Paginator } from 'foundations-components/transitional/components/Paginator';
import { SelectInput } from 'foundations-components/transitional/components/SelectInput';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EcosystemReviewsPaginator({
  collapsedPageLimit,
  expandable,
  expandButtonText,
  onUpdateFilters,
  pageCount,
  pageLimitOptions,
  reviewFilters
}) {
  if (pageCount <= 1) {
    return null;
  }
  if (expandable && reviewFilters.limit === collapsedPageLimit) {
    return /*#__PURE__*/_jsx(Button, {
      marginBlockStart: "400",
      onClick: () => onUpdateFilters({
        limit: pageLimitOptions[0]
      }),
      use: "link",
      children: expandButtonText || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-reviews.list.seeAll"
      })
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "space-between",
    marginBlockStart: "400",
    children: [/*#__PURE__*/_jsx(Paginator, {
      maxVisiblePageButtons: 5,
      onPageChange: ({
        target: {
          value
        }
      }) => {
        onUpdateFilters({
          page: value
        });
      },
      page: reviewFilters.get('page'),
      pageCount: pageCount
    }), pageLimitOptions.length > 1 && /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(SelectInput, {
        onChange: ({
          target: {
            value
          }
        }) => onUpdateFilters({
          limit: parseInt(value, 10)
        }),
        options: pageLimitOptions.map(limit => ({
          text: limit.toString(),
          value: limit.toString()
        })),
        value: reviewFilters.limit.toString()
      })
    })]
  });
}